// @ts-nocheck

import { createSelector } from 'reselect';

import { selectUserPromotionStatus } from '../../../selectors/user/userPrimary.selector';
import { type StateType } from '../../../states';
import { PromotionStatuses } from '../../../types/promotions';
import { GROperationUserStatuses } from '../types/user';

const emtpyObj = {};
const emptyArray: [] = [];

export const selectGRUserState = createSelector(
  (state: StateType) => state.gr.user,
  (user) => user ?? emtpyObj,
);

export const selectGRUserBetslips = createSelector(selectGRUserState, (user) => user.betslips ?? emptyArray);

export const selectGRUserStatus = createSelector(selectGRUserState, (user) => user.status);

export const selectGRUserRoundId = createSelector(selectGRUserState, (user) => user.round);

export const selectGRUserProgress = createSelector(selectGRUserState, (user) => user.progress ?? null);

export const selectGRUserNotifications = createSelector(selectGRUserState, (user) => user.notifications ?? emptyArray);

export const selectGRUserCurrentRound = createSelector(
  [selectGRUserRoundId, selectGRUserProgress],
  (roundId, progress) => progress?.[roundId],
);

export const selectGRUserCurrentRoundStatus = createSelector([selectGRUserCurrentRound], (round) => round?.status);

export const selectIsGRUserOptIn = createSelector(
  [selectGRUserStatus],
  (userStatus) => userStatus === GROperationUserStatuses.IN,
);

export const selectIsGRUserForbidden = createSelector(
  [selectGRUserStatus, selectUserPromotionStatus],
  (userStatus, promotionStatus) =>
    userStatus === GROperationUserStatuses.EXCLUDED || promotionStatus !== PromotionStatuses.DEFAULT,
);
